import styled from "styled-components";

export const LeftSidebar = styled.div`
  width: 25%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  @media (max-width: 1200px) {
    display: none;
  }
`;

export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: calc(50% - 3rem);

  @media (max-width: 1400px) {
    width: calc(75% - 1.5rem);
  }

  @media (max-width: 1200px) {
    width: 100%;
  }
`;

export const RightSidebar = styled.div`
  width: 25%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  @media (max-width: 1400px) {
    display: none;
  }
`;
